if (SEGMENT_API_KEY != undefined) {
  analytics.load(SEGMENT_API_KEY);
}

document.addEventListener('turbo:load', function() {
  var el = document.getElementById('segment-events');
  if (!el) return;

  analytics.page();
  JSON.parse(el.getAttribute('data-events') || '[]').forEach(function(event) {
    analytics.track(event.name, event.properties);
  });
  el.setAttribute('data-events', '[]');
});
